var _path, _rect, _path2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 93,
    viewBox: "0 0 107 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 25.5L80.6232 3.58933C83.7925 2.7089 87.0798 4.54436 87.9932 7.70434L96.75 38",
    stroke: "#69706E",
    strokeWidth: 5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 101,
    height: 73,
    rx: 6,
    fill: "#CAD8D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8337 81.4167H13.0003C12.1163 81.4167 11.2684 81.0655 10.6433 80.4404C10.0182 79.8153 9.66699 78.9674 9.66699 78.0834V64.75V63.9167C9.66699 63.0327 10.0182 62.1848 10.6433 61.5597C11.2684 60.9346 12.1163 60.5834 13.0003 60.5834H30.5003C31.3844 60.5834 32.2322 60.9346 32.8573 61.5597C33.4825 62.1848 33.8337 63.0327 33.8337 63.9167M26.7503 75.1667V73.3817C26.7503 72.065 27.8703 71 29.2503 71C30.6303 71 31.7503 72.0667 31.7503 73.3817V75.1667M24.667 75.5834V81.4167C24.667 81.8587 24.8426 82.2827 25.1551 82.5952C25.4677 82.9078 25.8916 83.0834 26.3337 83.0834H32.167C32.609 83.0834 33.0329 82.9078 33.3455 82.5952C33.6581 82.2827 33.8337 81.8587 33.8337 81.4167V75.5834H24.667Z",
    stroke: "#058A64",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 56,
    width: 44,
    height: 14,
    rx: 6,
    fill: "#69706E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnection);
export default __webpack_public_path__ + "static/media/wallet-connection.88db9b9842d89c04f008a805eaf8693c.svg";
export { ForwardRef as ReactComponent };